"use client";

import React from "react";
import { IconType } from "react-icons";

interface FormFieldProps {
  type: "text" | "email" | "tel" | "textarea";
  label: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: (value: string) => void;
  error?: string;
  placeholder?: string;
  required?: boolean;
  icon?: IconType;
  rows?: number;
  disabled?: boolean;
}

export default function FormField({
  type,
  label,
  value,
  onChange,
  onBlur,
  error,
  placeholder,
  required = false,
  icon: Icon,
  rows = 4,
  disabled = false,
}: FormFieldProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onChange(e.target.value);
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (onBlur) {
      onBlur(e.target.value);
    }
  };

  return (
    <div>
      <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
        {Icon && <Icon className="text-gray-500" />}
        {label} {required && "*"}
      </label>
      {type === "textarea" ? (
        <textarea
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={disabled}
          className={`w-full px-4 py-3 border rounded-lg focus:border-transparent focus:ring-2 focus:ring-primary/20 transition-all ${
            error ? "border-red-500" : "border-gray-300"
          } ${disabled ? "bg-gray-50 cursor-not-allowed" : ""}`}
          placeholder={placeholder}
          rows={rows}
        />
      ) : (
        <input
          type={type}
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={disabled}
          className={`w-full px-4 py-3 border rounded-lg focus:border-transparent focus:ring-2 focus:ring-primary/20 transition-all ${
            error ? "border-red-500" : "border-gray-300"
          } ${disabled ? "bg-gray-50 cursor-not-allowed" : ""}`}
          placeholder={placeholder}
        />
      )}
      {error && (
        <p className="text-red-500 text-sm mt-1">{error}</p>
      )}
    </div>
  );
} 